
/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  DeletionTaskSchedulingRequest,
} from '../models';
import {
    DeletionTaskSchedulingRequestFromJSON,
    DeletionTaskSchedulingRequestToJSON,
} from '../models';

export interface ScheduleDeletionTaskRequest {
    deletionTaskSchedulingRequest: DeletionTaskSchedulingRequest;
}

/**
 * 
 */
export class AccountDeletionTaskTestingApi extends runtime.BaseAPI {

    /**
          */
    async scheduleDeletionTaskRaw(requestParameters: ScheduleDeletionTaskRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['deletionTaskSchedulingRequest'] == null) {
            throw new runtime.RequiredError(
                'deletionTaskSchedulingRequest',
                'Required parameter "deletionTaskSchedulingRequest" was null or undefined when calling scheduleDeletionTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/account-deletion-admin/testing/deletion-task`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeletionTaskSchedulingRequestToJSON(requestParameters['deletionTaskSchedulingRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async scheduleDeletionTask(requestParameters: ScheduleDeletionTaskRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.scheduleDeletionTaskRaw(requestParameters, initOverrides);
    }

}
